import React, { useEffect } from 'react';
import { SvgIcon, useTheme, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from 'react-router-dom';
import "./Sidebar.scss";

const SidebarContainer = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'fixed',
  top: 0,
  left: 0,
  transition: 'width 0.3s ease-in-out',
  overflowX: 'hidden',
  zIndex: 9999,
}));

const StyledToggleIcon = styled(SvgIcon)({
  cursor: 'pointer',
});

export default function Sidebar({ expanded, setExpanded, navLinks, setActiveNavLink, environment, onEnvironmentChange }) {
  const theme = useTheme();
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('lg'));

  useEffect(() => {
    setExpanded(!isTabletOrMobile);
  }, [isTabletOrMobile]);

  return (
    <SidebarContainer id="advisor-sidebar" className={expanded ? 'advisor-sidebar-expanded' : 'advisor-sidebar-collapsed'}>
      <div id="sidenav-head">
        <img alt="Covr Logo" src={"/AdvisorImages/covr-logo-white.svg"} />
        {expanded ?
          (<StyledToggleIcon component={MenuOpenIcon} onClick={() => setExpanded(false)} />) :
          (<StyledToggleIcon component={MenuIcon} onClick={() => setExpanded(true)} />)}
      </div>

      <div className="sidenav pt-0">
        {navLinks.map((item, index) => (
          <SidebarLink
            key={index}
            isActive={item.isActive}
            text={item.text}
            iconElement={<SvgIcon component={item.icon} color="secondary" />}
            link={item.link}
            setActiveNavLink={setActiveNavLink}
            index={index}
            expanded={expanded}
          />
        ))}
      </div>
    </SidebarContainer>
  );
}

function SidebarLink({ link, text, iconElement, isActive, setActiveNavLink, index, expanded }) {
  return (
    <Link className={isActive ? 'active' : ''} title={text.toString()} onClick={() => setActiveNavLink(index)} to={link}>
      {iconElement}&nbsp;{expanded ? <span>{text}</span> : null}
    </Link>
  );
}
